<template>
  <div>
    <list-vue
      v-bind:busqueda="busqueda"
      v-bind:busquedaTraduccion="busquedaTraduccion"
      v-bind:busquedaMedidas="busquedaMedidas"
      v-bind:opciones="opciones"
      v-bind:moduloTitulo="moduloTitulo"
      v-bind:pantallaTitulo="pantallaTitulo"
      v-bind:rutaConsulta="rutaConsulta"
      v-bind:buttonsPage="buttonsPage"
      v-bind:busquedaCampos="busquedaCampos"
    ></list-vue>
  </div>
</template>
<script type="text/javascript">
export default {
  props: ["request"],
  data() {
    return {
      //Definimos los nombres generales
      moduloTitulo: this.$root.trans("Reporte General"),
      reporte: false,
      pantallaTitulo: this.$root.trans("Resultado"),
      rutaConsulta: "./reportes-general-generar",
      buttonsPage: [
        // {
        //     type        :   'button',
        //     class       :   'btn btn-xs btn-info pull-right',
        //     route       :   'AuthorsCreate',
        //     text        :   '<i class="fa fa-plus">',
        //     description :   '<i class="fa fa-plus">',
        // }
      ],
      //Definimos los campos de busqueda, sus nombres e incluso tamaño
      busqueda: {
        fi___fecha: "",
        fecha_final_etapa: "",
        codigo: "",
        fi___descripcion: "",
        nombre_creador: "",
        tn___descripcion: "",
        fica___valor_version: "",
        en___descripcion: "",

        destinatarios_actuales: "",
      },
      busquedaTraduccion: {
        fi___fecha: this.$root.trans("Fecha Creación"),
        fecha_final_etapa: this.$root.trans("Fecha E. Actual"),
        codigo: this.$root.trans("Codigo"),
        fi___descripcion: this.$root.trans("Descripción"),
        fica___valor_version: this.$root.trans("Versión"),
        nombre_creador: this.$root.trans("Creador"),
        tn___descripcion: this.$root.trans("Tipo de NC"),
        en___descripcion: this.$root.trans("Etapa Actual"),

        destinatarios_actuales: this.$root.trans("Responsable"),

        // fi___nro_ficha:this.$root.trans('ID'),

        // cs___descripcion:this.$root.trans('Nombre'),
        // fica___valor_version:this.$root.trans('Nombre'),
      },
      busquedaCampos: {
        fi___fecha: {
          type: "readonly",
        },
        fecha_final_etapa: {
          type: "readonly",
        },
        destinatarios_actuales: {
          type: "readonly",
        },
        nombre_creador: {
          type: "readonly",
        },
        codigo: {
          type: "readonly",
        },
      },
      busquedaMedidas: {
        fi___fecha: "90px",
        fecha_final_etapa: "90px",
        codigo: "83px",
        fi___descripcion: "",
        nombre_creador: "87px",
        tn___descripcion: "106px",
        en___descripcion: "119px",
        destinatarios_actuales: "83px",

        // fi___nro_ficha:'',

        // cs___descripcion:'',
        fica___valor_version: "84px",
      },
      //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
      opciones: [
        // {
        //     class:'btn btn-sm btn-warning',
        //     icon:'fas fa-edit',
        //     routerName:'AuthorsEdit',
        //     param:'id',
        //     eliminar:false,
        //     nombre:'Editar'
        // },
        // {
        //     class:'btn btn-sm btn-danger',
        //     icon:'fa fa-trash-alt',
        //     routerName:'/backend/authors/delete/',
        //     param:'id',
        //     eliminar:true,
        //     nombre:'Eliminar'
        // }
      ],
    };
  },
  mounted() {

    if (typeof this.$store.state.request.categoriaNC !== "undefined") {
      this.reporte = this.$store.state.request.categoriaNC;
    }

    if (this.reporte === "NO") {
      // this.busquedaTraduccion['fica___valor_version']=this.$root.trans('Versión'),
      // this.busquedaMedidas['fica___valor_version']="90px";
    } else {
      delete this.busqueda["fica___valor_version"];
      delete this.busquedaTraduccion["fica___valor_version"];
      delete this.busquedaMedidas["fica___valor_version"];

      this.$delete(this.busqueda, "fica___valor_version");
      this.$delete(this.busqueda, 1);
      this.busqueda["sujeto"] = "";
      this.busquedaTraduccion["sujeto"] = this.$root.trans("Sujeto");
      this.busquedaMedidas["sujeto"] = "90px";

      this.busqueda["proceso_descripcion"] = "";
      this.busquedaTraduccion["proceso_descripcion"] =
        this.$root.trans("Proceso");
      this.busquedaMedidas["proceso_descripcion"] = "90px";

      this.busqueda["clasificacion"] = "";
      this.busquedaTraduccion["clasificacion"] = this.$root.trans("Clasific.");
      this.busquedaMedidas["clasificacion"] = "90px";
    }
  },
};
</script>
